import "./App.css";
import HomePage from "./pages/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./pages/Navbar";
import Footer from "./pages/Footer";
import MembershipPage from "./pages/MembershipPage";
import MembersListPage from "./pages/MembersListPage";
import AdminLoginPage from "./pages/AdminLoginPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};


function App() {
  return (
    <>
      <Router>
        <ScrollToTop /> 
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
           <Route path="/membership" element={<MembershipPage />} />
           <Route path="/registered-members" element={<MembersListPage />} />
           <Route path="/login/admin" element={<AdminLoginPage />} />
        </Routes>
        <Footer />
      </Router>
    </>
  );
}

export default App;
